'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const CreditCardIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M2.89245 12.3172H15.96M17.63 16.12L18.7484 16.38C19.3084 16.48 19.8384 16.11 19.9384 15.55L21.2384 8.16004C21.3384 7.60004 20.9684 7.07004 20.4084 6.97004L9.22996 4.96004C8.66996 4.86004 8.13996 5.23004 8.03996 5.79004L7.63996 8.09004M15.2601 19.2584H3.76255C3.21255 19.2584 2.76255 18.8084 2.76255 18.2584L2.76251 14.285L2.76245 10.7672C2.76245 10.2172 3.21245 9.76723 3.76245 9.76723H15.26C15.81 9.76723 16.26 10.2172 16.26 10.7672L16.2601 18.2584C16.2601 18.8084 15.8101 19.2584 15.2601 19.2584ZM13.67 14.5H10.2V16.62H13.67V14.5Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpCreditCardIcon = forwardRef(CreditCardIcon);

export { VpCreditCardIcon as default };
